import React, { useEffect, useState } from "react";
import {
    Box,
    Grid,
    Typography,
    List,
    ListItemButton,
    ListItemText,
  
    Breadcrumbs,
    Link as MLink,

    Container,
} from "@mui/material";

import { Link } from "react-router-dom";

import '../../../App.css'
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import { axiosInstance } from "../../../Api/Axios/axios";
import { endpoints } from "../../../Api/EndPoints/endpoints";


const leftMenu = [
    "WITHERING",
    "ROLLING",
    "FERMENTING",
    "DRYING",
    "SORTING",
    "PACKING",
    "WORKSHOP EQUIPMENT",
    "QUALITY CONTROL EQUIPMENT",
    "UTILITIES",
];

const Utilities = () => {

    const [data, setData] = useState([])
    const [parsedData, setparseddata] = useState([])

    const getData = async () => {
        try {
            const res = await axiosInstance.get(endpoints.teaProcessingMachinery.utilities)
            setData(res?.data?.data)
            if (res?.data?.data) {
                const list = JSON.parse(res?.data?.data.section1_list);
                setparseddata(list)
            }
        }
        catch (err) {
            console.log(err)
        }
    }

    useEffect(() => {
        getData()
        window.scrollTo({
            top: 0,
            behavior: "smooth"
        });
    }, []);


    return (
        <Box sx={{ padding: { xs: 2, md: 4 }, mt: "100px"  }}>
            <Container maxWidth='xl'>
                {/* Breadcrumb */}
                <Breadcrumbs sx={{ mb: 2, fontSize: "15px" }}>
                    <MLink component={Link} to="/" underline="hover" color="inherit">
                        Home
                    </MLink>
                    <Typography color="inherit" sx={{ fontSize: "15px" }}>Product & Services</Typography>
                    <Typography color="text.primary" sx={{ fontSize: "15px" }}>CTC Tea Processing Machinery</Typography>
                    <Typography color="text.primary" sx={{ fontSize: "15px" }}>Utilities</Typography>
                </Breadcrumbs>




                <Grid container spacing={3}>
                    {/* Left Sidebar */}
                    <Grid item size={{ xs: 12, md: 3 }} sx={{ mt: 2 }}>
                        <Typography
                            sx={{
                                fontWeight: 700,
                                fontSize: "15px",
                                mb: 2,
                                textTransform: "uppercase",
                                fontFamily: "Roboto"
                            }}
                        >
                            Product & Services
                        </Typography>



                        <List sx={{ border: "1px solid #ddd" }}>
                            {leftMenu.map((item) => (
                                <ListItemButton
                                    key={item}
                                    component={Link}
                                    to={`/products/ctc/${item.toLowerCase().replace(/ /g, "-")}`}
                                    sx={{
                                        borderBottom: "1px solid #eee",
                                        backgroundColor: item === "UTILITIES" ? "green" : "transparent",
                                        color: item === "UTILITIES" ? "#fff" : "#000",
                                        "&:hover": {
                                            backgroundColor: item === "UTILITIES" ? "green" : "#f5f5f5",
                                        },
                                        fontFamily: "Roboto"
                                    }}
                                >
                                    <ListItemText
                                        primary={item}
                                        primaryTypographyProps={{
                                            fontSize: "14px",
                                            fontWeight: 500,
                                            fontFamily: "Roboto"
                                        }}
                                    />
                                </ListItemButton>
                            ))}
                        </List>
                    </Grid>

                    {/* Right Content Section */}
                    <Grid item size={{ xs: 12, md: 9 }} sx={{ mt: 6 }}>
                        <Typography
                            sx={{
                                fontSize: "24px",
                                fontWeight: 600,
                                mb: 0,
                                fontFamily: "Roboto",
                                color: "red"
                            }}
                        >
                            {data?.section1_title}
                        </Typography>




                        {/* Technical Specification Table */}
                        {/* Technical Specifications */}
                        {
                            parsedData?.map((item) => {
                                return (
                                    <Typography
                                        sx={
                                            headingStyle
                                        }
                                    >
                                        <ChevronRightIcon sx={{ color: "red", fontSize: "34px" }} />  
                                       {item}
                                    </Typography>
                                )
                            })
                        }









                    </Grid>
                </Grid>
            </Container>
        </Box>
    );
};

const headingStyle = {
    fontSize: "20px",
    fontWeight: 600,
    mt: 4,
    mb: 2,
    fontFamily: "Roboto",
    display: "flex",
    alignItems: "center",
    gap: 1,
    px: 2,
    py: 1.5,
    borderTop: "3px solid #e5e5e5",
    borderBottom: "3px solid #e5e5e5",
    boxShadow: "0 4px 12px rgba(0,0,0,0.12)",
    borderRadius: "6px",
    background: "#fff"
};


export default Utilities;
